// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MelbourneAirportTaxiRouteImport } from './routes/melbourne-airport-taxi'
import { Route as LongDistanceTaxiRouteImport } from './routes/long-distance-taxi'
import { Route as CorporateTaxiRouteImport } from './routes/corporate-taxi'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ChauffeurServicesRouteImport } from './routes/chauffeur-services'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SuburbsIndexRouteImport } from './routes/suburbs.index'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as SuburbsSuburbRouteImport } from './routes/suburbs.$suburb'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'

const MelbourneAirportTaxiRoute = MelbourneAirportTaxiRouteImport.update({
            id: '/melbourne-airport-taxi',path: '/melbourne-airport-taxi',getParentRoute: () => rootRouteImport
          })
const LongDistanceTaxiRoute = LongDistanceTaxiRouteImport.update({
            id: '/long-distance-taxi',path: '/long-distance-taxi',getParentRoute: () => rootRouteImport
          })
const CorporateTaxiRoute = CorporateTaxiRouteImport.update({
            id: '/corporate-taxi',path: '/corporate-taxi',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ChauffeurServicesRoute = ChauffeurServicesRouteImport.update({
            id: '/chauffeur-services',path: '/chauffeur-services',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SuburbsIndexRoute = SuburbsIndexRouteImport.update({
            id: '/suburbs/',path: '/suburbs/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const SuburbsSuburbRoute = SuburbsSuburbRouteImport.update({
            id: '/suburbs/$suburb',path: '/suburbs/$suburb',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,ChauffeurServicesRoute: ChauffeurServicesRoute,ContactRoute: ContactRoute,CorporateTaxiRoute: CorporateTaxiRoute,LongDistanceTaxiRoute: LongDistanceTaxiRoute,MelbourneAirportTaxiRoute: MelbourneAirportTaxiRoute,BlogSlugRoute: BlogSlugRoute,SuburbsSuburbRoute: SuburbsSuburbRoute,BlogIndexRoute: BlogIndexRoute,SuburbsIndexRoute: SuburbsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)